export const AUTH_USER_LOGIN = 'AUTH_USER_LOGIN';
export const AUTH_USER_SIGNIN_FROM_STORAGE = 'AUTH_USER_SIGNIN_FROM_STORAGE';
export const AUTH_USER_LOGOUT = 'AUTH_USER_LOGOUT';